import { socialDictionary } from "@brexhq/next/src/constants/social";

import { SocialIconsProps } from "./types";

export const SocialIcons: Array<SocialIconsProps> = [
  {
    icon: "Facebook",
    to: socialDictionary.facebook.url,
  },
  {
    icon: "Youtube",
    to: socialDictionary.youtube.url,
  },
  {
    icon: "Instagram",
    to: socialDictionary.instagram.url,
  },
  {
    icon: "Linkedin",
    to: socialDictionary.linkedin.url,
  },
  {
    icon: "Twitter",
    to: socialDictionary.twitter.url,
  },
];
